import React from 'react';
import { TextField, Box, Typography } from '@mui/material';

const ProjectInfoFields = ({ form, handleChange, width = '50%', disabled = false }) => {
  return (
    <>
      <Typography variant="h3" fontWeight={700} color="black" mt={4}>
        Project info
      </Typography>
      <Typography variant="h6" color="rgb(158, 151, 151)" mt={2}>
        Fill in your project details.
      </Typography>

      <Box
        sx={{
        width: width,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        padding: 2,
        mt: 3,
        }}
      >
        <Typography variant="h7" color="black">
          Project name
        </Typography>
        <TextField
          required
          label="Project name"
          name="name"
          value={form.name}
          onChange={handleChange}
          fullWidth
          autoComplete="off"
          disabled={disabled}
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
        />

        <Typography variant="h7" color="black" mt={2}>
          Description
        </Typography>
        <TextField
          required
          label="Describe your project"
          name="description"
          value={form.description}
          onChange={handleChange}
          multiline
          rows={4}
          fullWidth
          disabled={disabled}
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
        />
      </Box>
    </>
  );
};

export default ProjectInfoFields;
